const Packages = [
    {
        id: 1,
        imageUrl : "https://i.ibb.co/w4mh9Kk/Screenshot-from-2021-10-17-10-03-57.png",
        title : "Cosmic CSS",
        desc : "Cosmic is a CSS Framework ☄️. It has More Unique Component Designs eg: Bouncing Button, Neumorphism, Responsive Cards, Rainbow Spinner, etc.,",
        needs : [
            {
                id :1,
                skill : "CSS",
                color : "#5797ff"
            },
        ],
        npmUrl : "https://www.npmjs.com/package/cosmiccss",
    },
    {
        id: 2,
        imageUrl : "https://i.ibb.co/k8xKh4F/Screenshot-from-2021-10-17-10-04-18.png",
        title : "Toastm",
        desc : "It's Just a Package for Popup Toast / Notification Message 📜",
        needs : [
            {
                id : 1,
                skill : "CSS",
                color : "#5797ff"
            },
            {
                id : 2,
                skill : "Javascript",
                color : "#ffec73"
            },
        ],
        npmUrl : "https://www.npmjs.com/package/toastm",
    },
]

export default Packages;